import React from 'react';

const TitleLastProjects = () => (
    <h1 className="title-page-last-projects">
    Estos son mis ultimos proyectos, que desmuestran lo que soy capaz. Algunos son paginas webs, otras son diseños y otros pueden ser practicas pequeñas pero significativas de lo que hago y lo que te puedo hacer.
    </h1>
)

export default TitleLastProjects;